export enum LookupResTypeEnum {

  OzelKod = 'ozelKod',
  Kod = 'kod',
  Aciklama = 'aciklama',

}


export type LookupResType = {
  kod: number;
  ozelKod: string;
  aciklama: string;
}